<template>
  <van-row class="white-page-bg payment-cb">
    <van-col span="24">
      <info-message class="itserve-center place-content-center">
        <img
            src="@/assets/images/action_success.png"
            alt="success-action"
        /><br />
        {{ $t("pay.paymentSuccessful") }}
      </info-message>
      <button class="donora-success-btn" type="button" @click="openDonora">
        <span class="donora-success-heart" aria-hidden="true">
          <svg viewBox="0 0 64 64">
            <path
              d="M32 52S10 39 10 23c0-7 5-12 12-12 4 0 8 2 10 6 2-4 6-6 10-6 7 0 12 5 12 12 0 16-22 29-22 29Z"
            />
          </svg>
        </span>
        <span>{{ $t("pay.donoraCta") }}</span>
      </button>
    </van-col>
  </van-row>
</template>

<script>
import InfoMessage from "@/components/content/InfoMessage";
import { getDonoraUrl } from "@/views/account/edopomoga/donoraLinks";
export default {
  components: { InfoMessage },
  name: "Success",
  methods: {
    openDonora() {
      this.openExternalUrl(getDonoraUrl(this.$store.state.Auth.app_id));
    },
    openExternalUrl(url) {
      if (typeof this.nativeSendEvent === "function") {
        this.nativeSendEvent("url", url);
        return;
      }

      window.open(url, "_blank", "noopener");
    },
  },
};
</script>

<style scoped>
.donora-success-btn {
  width: min(337px, calc(100% - 32px));
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin: 18px auto 0;
  padding: 12px 18px;
  border: 1px solid rgba(120, 164, 255, 0.75);
  border-radius: 18px;
  background: linear-gradient(135deg, #4f83ff 0%, #2867ee 100%);
  color: #ffffff;
  font-size: clamp(17px, 4.4vw, 20px);
  font-weight: 900;
  line-height: 1.15;
  letter-spacing: 0;
  box-shadow: 0 12px 28px rgba(40, 103, 238, 0.38);
}

.donora-success-heart {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  animation: donora-heart-pulse 1.35s ease-in-out infinite;
}

.donora-success-heart svg {
  width: 36px;
  height: 36px;
  fill: none;
  stroke: currentColor;
  stroke-width: 4.4;
  stroke-linecap: round;
  stroke-linejoin: round;
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.38));
}

@keyframes donora-heart-pulse {
  0%,
  100% {
    transform: scale(1);
  }

  45% {
    transform: scale(1.12);
  }
}
</style>
